import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import {
    Input,
    TextArea,
    InputNumeric,
    Form,
    Switch,
    Button
} from '@gpstrackit/gtc-react-controls';

const Number = (props) => {
    const { messages } = useIntl();
    const questionForm = Form.useForm();

    const {
        question,
        handleClose,
        updateQuestion
    } = props;

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);

    const [formData,  setFormData] = useState({});

    const [min, setMin] = useState();
    const [max, setMax] = useState();

    useEffect(() => {
        if (open && questionForm?.ref && question) {
            questionForm?.setValues({
                ...question,
                default: question?.attributes?.default,
                minimum: question?.attributes?.minimum,
                maximum: question?.attributes?.maximum
            });
        }
    }, [questionForm?.ref, open, question]);


    return (
        <div>
            <Form
                ref={questionForm?.ref}
                loading={loading}
                onValidSubmit={(values) => {
                    let newQuestion = {
                        ...question,
                        label: values?.label,
                        placeHolder: values?.placeHolder,
                        help: values?.help,
                        required: values?.required,
                        readOnly: values?.readOnly,
                        attributes: {
                            default: values?.default,
                            minimum: values?.minimum,
                            maximum: values?.maximum,
                        }
                    }

                    updateQuestion(newQuestion);
                }}
                onChangeValues={(values) => {
                    setFormData(values)
                    setMin(values?.minimum);
                    setMax(values?.maximum);
                }}
            >
                <div>
                    <Form.Item
                        name="label"
                        label={messages['dynamicFormsDesign_label']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="label"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_label']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="placeHolder"
                        label={messages['dynamicFormsDesign_placeholder']}
                    >
                        <Input
                            id="placeHolder"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_placeholder']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="help"
                        label={messages['dynamicFormsDesign_helpText']}
                    >
                        <TextArea
                            id="help"
                            placeholder={messages['dynamicFormsDesign_helpText']}
                            maxLength={1000}
                        />
                    </Form.Item>

                    <Form.Item
                        name="required"
                        label={messages['dynamicFormsDesign_required']}
                    >
                        <Switch
                            id="required"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        readOnly: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="readOnly"
                        label={messages['dynamicFormsDesign_readOnly']}
                    >
                        <Switch
                            id="readOnly"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        required: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="default"
                        label={messages['dynamicFormsDesign_defaultValue']}
                        rules={[
                            { min: -99999999999, message: `${messages['dynamicFormsDesign_minValue']}: -99999999999` },
                            { max: 99999999999, message: `${messages['dynamicFormsDesign_maxValue']}: 99999999999` },
                        ]}
                    >
                        <InputNumeric
                            id="default"
                            type="number"
                            isInteger={true}
                            placeholder={messages['dynamicFormsDesign_defaultValue']}
                        />
                    </Form.Item>

                    <Form.Item
                        name="minimum"
                        label={messages['dynamicFormsDesign_minimum']}
                        rules={[
                            { min: -99999999999, message: `${messages['dynamicFormsDesign_minValue']}: -99999999999` },
                            { max: ((max != null && max != undefined) ? max : 99999999999), message: `${messages['dynamicFormsDesign_maxValue']}: ${ ((max != null && max != undefined) ? max : 99999999999)}` },
                        ]}
                    >
                        <InputNumeric
                            id="minimum"
                            type="number"
                            isInteger={true}
                            placeholder={messages['dynamicFormsDesign_minimum']}
                        />
                    </Form.Item>

                    <Form.Item
                        name="maximum"
                        label={messages['dynamicFormsDesign_maximum']}
                        rules={[
                            { min: ((min != null && min != undefined) ? min : -99999999999), message: `${messages['dynamicFormsDesign_minValue']}: ${ ((min != null && min != undefined) ? min : -99999999999)}` },
                            { max: 99999999999, message: `${messages['dynamicFormsDesign_maxValue']}: 99999999999` },
                        ]}
                    >
                        <InputNumeric
                            id="maximum"
                            type="number"
                            isInteger={true}
                            placeholder={messages['dynamicFormsDesign_maximum']}
                        />
                    </Form.Item>
                </div>
            </Form>

            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.resetValues()
                        handleClose();
                    }}
                    variant='secondary'
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.submit();
                    }}
                    variant='primary'
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    );
}

export default Number;